import { IconProps } from "../../../types/style";

const DiscountRewardsFilter = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M6 12.5C9.31368 12.5 12 9.81368 12 6.5C12 3.18629 9.31368 0.5 6 0.5C2.68629 0.5 0 3.18629 0 6.5C0 9.81368 2.68629 12.5 6 12.5Z"
          fill={color}
        />
        <path
          d="M7.80009 8.9002C7.46409 8.9002 7.19409 8.6302 7.19409 8.3002C7.19409 7.9702 7.46409 7.7002 7.79409 7.7002C8.12409 7.7002 8.39409 7.9702 8.39409 8.3002C8.39409 8.6302 8.13009 8.9002 7.80009 8.9002Z"
          fill={color}
        />
        <path
          d="M4.20598 5.3001C3.86998 5.3001 3.59998 5.0301 3.59998 4.7001C3.59998 4.3701 3.86998 4.1001 4.19998 4.1001C4.52998 4.1001 4.79998 4.3701 4.79998 4.7001C4.79998 5.0301 4.53598 5.3001 4.20598 5.3001Z"
          fill={color}
        />
        <path
          d="M4.19974 8.75C4.08574 8.75 3.97172 8.708 3.88172 8.618C3.70772 8.444 3.70772 8.15594 3.88172 7.98194L7.48175 4.38196C7.65575 4.20796 7.94375 4.20796 8.11775 4.38196C8.29175 4.55596 8.29175 4.844 8.11775 5.018L4.51776 8.618C4.42776 8.708 4.31374 8.75 4.19974 8.75Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default DiscountRewardsFilter;
